import { useNavigate } from "react-router-dom";
import ModalV2 from "../../../../components/ModalV2";
import useModal from "../../../../hooks/useModal";

export default function RWATypeSelectionModal({ onSelect, onClose }) {
  const navigate = useNavigate();
  const { close } = useModal('rwa-type-selector');

  // dynamically load all names from types folder
  const types = import.meta.glob('../types/*.jsx', { eager: true })
  const names = Object.keys(types).map(path => path.replace('../types/', '').replace('.jsx', '')).map(item =>
    item.replace(/([a-z])([A-Z])/g, '$1 $2')  // Insert space before capital letters
  );

  return (<ModalV2 name={"rwa-type-selector"} onClose={onClose} title="Create asset">
    <p className="text-sm mb-4">
        Choose what type of asset you want to create below.
    </p>
    <div className="flex flex-col space-y-2">
      {names.map((name) => {
        return (<button key={name} className="w-full py-6 bg-gray-100 rounded-lg hover:bg-gray-200"
          onClick={() => {
              navigate(`/dashboard/rwa/create/${name.replace(/ /g, '')}`); // Navigate to the create page for the selected type
              close(); // Close the modal
          }}>
          {name}
        </button>
        );
      })}
    </div>
  </ModalV2>);
}